import * as React from "react";

const WriteDatabase = (props: any) => (
  <svg width={64} height={64} viewBox="0 0 64 64" {...props}>
    <g fill="none" fillRule="evenodd">
      <path fill="none" d="M0 0h64v64H0z" fillOpacity={0} />
      <g strokeLinejoin="round">
        <g fill="#7B838C" stroke="#7B838C" strokeLinecap="round">
          <path d="M42.416 31.672v7.376c0 1.74-4.774 3.151-10.665 3.151-5.89 0-10.665-1.41-10.665-3.15v-7.377" />
          <path d="M42.416 24.348v7.376c0 1.74-4.774 3.151-10.665 3.151-5.89 0-10.665-1.41-10.665-3.15v-7.377" />
          <path d="M42.416 24.308c0 1.718-4.774 3.11-10.665 3.11-5.89 0-10.665-1.392-10.665-3.11s4.775-3.11 10.665-3.11c5.89 0 10.665 1.392 10.665 3.11z" />
        </g>
        <path
          d="M42.416 31.672v7.376c0 1.74-4.774 3.151-10.665 3.151-5.89 0-10.665-1.41-10.665-3.15v-7.377"
          stroke="#7B838C"
          strokeLinecap="round"
        />
        <path
          d="M43.305 31.724c0 1.74-5.172 3.151-11.554 3.151-6.38 0-11.553-1.41-11.553-3.15M43.305 24.308c0 1.718-5.172 3.11-11.554 3.11-6.38 0-11.553-1.392-11.553-3.11"
          stroke="#FFF"
        />
      </g>
      <path d="M8 23.515L16.485 32 8 40.485z" fill="#D2D5D8" />
    </g>
  </svg>
);

export default WriteDatabase;

